import * as React from 'react';
import classNames from 'classnames';

interface ViewDividerProps {
  className?: string;
  title: string;
}

/**
 * @name ViewDivider
 * @description tbd...
 */
const ViewDivider: React.FC<ViewDividerProps> = (props) => {
  const { className, title } = props;

  // Hooks

  // Setup

  // Styles

  // Handlers

  // Markup

  // Life Cycle

  // Short Circuit

  return (
    <div className={classNames(className, 'relative my-12')}>
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-gray-300" />
      </div>
      <div className="relative flex justify-start">
        <span className="pr-3 bg-white text-2xl font-medium text-gray-900">
          {title}
        </span>
      </div>
    </div>
  );
};

export { ViewDivider };
export type { ViewDividerProps };
